export const LABEL_STYLE = 'text-primary-900 flex-shrink-0';
export const LABEL_STYLE_COLLAPSE = 'lg:group-[.collapsed]:hidden';
export const BUTTON_STYLE =
  'hover:bg-primary-100 flex items-center flex-shrink-0 rounded-[8px] px-[12px] py-[8px] w-full hover:bg-opacity-80 text-primary-900 gap-2';
export const BUTTON_STYLE_COLLAPSE =
  'lg:group-[.collapsed]:rounded-[8px] lg:group-[.collapsed]:w-fit lg:group-[.collapsed]:p-3';
export const NAV_ACTIVE_STYLE = 'bg-primary-100 text-primary-900 hover:bg-opacity-100';
export const EYEBROW_STYLE =
  'px-3 pt-4 pb-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-gray-400 lg:group-[.collapsed]:hidden';
